<template>
  <div class="b-youtube-video">
    <div :class="overlay"></div>
    <transition-group name="fade">
      <Loader v-if="(playerState <= 0 && loop) || playerState < 0"></Loader>
      <img
        v-if="playerState <= 0 && videoPlaceholder"
        :src="videoPlaceholder"
        class="b-youtube-video__cover"
        alt="trailer placeholder" />
    </transition-group>

    <div
      :id="videoId"
      ref="video"
      class="b-youtube-video__player"
      :class="playerState ? '' : 'ui-helper-hidden-accessible'"></div>
    <slot name="videoContent" :video-id="videoId"></slot>

    <!-- <button type="button" style="position: absolute; top: 0; z-index: 22;" @click="play">play</button> -->
  </div>
</template>

<script setup>
import { makeId } from '../../lib/lib'
import { nextTick, onMounted, ref } from 'vue'
import featureYouTubeVideo from '../../features/feature-youtube-video'
import constants from '../../lib/constants'
import Loader from './Shared/Loader.vue'

const emit = defineEmits([
  'video-percent',
  'on-player-state-change',
  'on-player-ready',
  'update:modelValue',
])

const props = defineProps({
  loop: { default: false, type: Boolean },
  youtubeId: { default: '', type: String },
  autoplay: { default: 0, type: Number },
  videoPlaceholder: { default: '', type: String },
  youtubeScale: { default: '', type: String },
  overlay: { default: 'b-youtube-video__overlay', type: String },
  muted: { default: false, type: Boolean },
})

const playerState = ref(-1)
const videoPlaceholder = ref(props.videoPlaceholder)

const videoId = makeId()

const ytb = new featureYouTubeVideo({
  youtubeId: props.youtubeId,
  videoId: videoId,
  loop: props.loop,
  muted: props.muted,
  autoplay: props.autoplay,
  onProgress(progress) {
    emit('video-percent', progress)
  },
  onPlayerStateChange(ev, player, descr) {
    // console.log('onPlayerStateChange muted', props.muted)
    
    if (props.muted) {
      player.mute()
      updateMuteState(true)
      // player.setVolume(0)
      emit('update:modelValue', false)
    } else {
      player.unMute()
      updateMuteState(false)
      emit('update:modelValue', true)

      // player.setVolume(100)
    }
    playerState.value = ev.data
    emit('on-player-state-change', ev, player, descr)
  },
  onPlayerReady(ev, player) {
    // console.log('onPlayerReady muted', props.muted)

    updateMuteState(props.muted)
    if (props.muted) {
      mute()
      emit('update:modelValue', false)
    } else {
      emit('update:modelValue', true)
    }
    emit('on-player-ready', player)

  },
})

onMounted(async () => {
  // make sure youtube api initialized before create new one to prevent memory leak
  // as this component may be used more than one time in the same page
  if (!constants.youtube) {
    document.addEventListener('on-youtube-iframe-api-ready', () => {
      ytb.createVideo()
    })
  }
  await nextTick()
  addSliderDimensions()
  if (ytb && constants.youtube) {
    ytb.createVideo()
  }
})

const stop = () => {
  ytb.stop()
}

const play = () => {
  ytb.play()
}

const updateMuteState = (state) => {
  ytb.changeMuteState(state)
}

const replay = () => {
  ytb.stop()
  ytb.currentTime = '0'
  ytb.play()
}

const mute = () => {
  ytb.mute()
  emit('update:modelValue', false)
}

const unMute = () => {
  ytb.unMute()
  emit('update:modelValue', true)
}

const pauseVideo = () => {
  ytb.pauseVideo()
}

const addSliderDimensions = () => {
  const videoEl = document.getElementById(videoId)
  if (props.youtubeScale && videoEl) {
    videoEl.style.transform = props.youtubeScale
  }
}

const loadVideoById = (vid) => {
  nextTick(() => {
    if (ytb && ytb.player !== null) {
      ytb.loadVideoById(vid)
    }
  })
}
const isMuted = () => {
  return ytb.player.isMuted()
}
defineExpose({
  stop,
  play,
  pauseVideo,
  mute,
  unMute,
  loadVideoById,
  isMuted,
  replay,
})
</script>
